var map = {
	"./AAVE.svg": 1130,
	"./AVAX.svg": 1131,
	"./BUSD.svg": 1132,
	"./COMP.svg": 1133,
	"./DAI.svg": 1134,
	"./DYDX.svg": 1135,
	"./ETH.svg": 313,
	"./FRAX.svg": 1136,
	"./FTM.svg": 1137,
	"./FXS.svg": 1138,
	"./LDO.svg": 1139,
	"./LINK.svg": 1140,
	"./LOOKS.svg": 1141,
	"./LUNA.svg": 1142,
	"./MANA.svg": 1143,
	"./MATIC.svg": 1144,
	"./METIS.svg": 1145,
	"./MKR.svg": 1146,
	"./SHIB.svg": 1147,
	"./SOL.svg": 1148,
	"./STORJ.svg": 1149,
	"./UNI.svg": 1150,
	"./USDC.svg": 1151,
	"./USDT.svg": 417,
	"./UST.svg": 1152,
	"./VERI.svg": 1153,
	"./WBTC.svg": 1154,
	"./YFI.svg": 1155,
	"./agEUR.svg": 1156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1129;